import { useIsOnSemanticSearch } from '@hooks/use-is-on-semantic-search';
import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { CtaButton } from '@tkww/orion-web-ds-action';
import React, { type FC, useCallback } from 'react';
import AnalyticsEvents from '../../../../../marketplace-web/constants/analytics';
import Styles from './VenueFacetLinks.styles.scss';

export type FacetLinkProps = {
	href: string;
	isLastItem: boolean;
	label: string;
};

export const FacetLink: FC<FacetLinkProps> = ({ href, isLastItem, label }) => {
	const { isOnSemanticSearch } = useIsOnSemanticSearch();
	const sourcePage = isOnSemanticSearch
		? 'semantic results'
		: 'category results';

	const { track } = useAnalyticsContext();
	const trackLinkClicked = useCallback(() => {
		const properties = {
			sourcePage: sourcePage,
			sourceContent: 'venue_facet_links',
			selection: [label.toLowerCase()],
		};

		track({
			event: AnalyticsEvents.LINK_CLICKED,
			properties,
		});
	}, [track, label, sourcePage]);

	return (
		<>
			<CtaButton
				className={Styles.link}
				styleType="tertiary-alternative"
				as="a"
				treatAs="link"
				href={href}
				size="lg"
				onClick={trackLinkClicked}
			>
				{label}
			</CtaButton>
			{!isLastItem && (
				<span className={Styles.dot} data-testid="dot">
					&#8226;
				</span>
			)}
		</>
	);
};
